export const OPERATING_FLUID_MAIL_ADDRESS = 'operatingfluids@mercedes-benz.com';
export const OPERATING_FLUID_URL_ADDRESS = 'https://operatingfluids.mercedes-benz.com/';
export const OPERATING_FLUID_URL_QR_CODE_ADDRESS = 'https://operatingfluids.mercedes-benz.com/qrcode/';

export enum UrlsCollection {
    PRIVACY_POLICY_LINK = 'https://group.mercedes-benz.com/datenschutzrichtlinie',
    ONLINE_DISPUTE_LINK = 'https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage',
    UMAS_CHANGE_DATA_LINK = 'https://aftersales.mercedes-benz.com/umas/registration/#/',
    Provider_MAIL_ADDRESS = 'dialog@mercedes-benz.com',
    OPERATING_FLUID_MAIL_ADDRESS = 'operatingfluids@mercedes-benz.com',
    MBOX_DATENSCHUTZ_ADRESS = 'mbox_datenschutz@mercedes-benz.com',
}
